import { Component, Input, OnInit } from '@angular/core';
import { SettingsService } from '@delon/theme';

@Component({
  selector: 'app-inventory-tranx-summary',
  templateUrl: './inventory-tranx-summary.component.html',
  styleUrls: ['./inventory-tranx-summary.component.less'],
  standalone: false
})
export class InventoryTranxSummaryComponent implements OnInit {
  @Input() totalAmount: number | null | undefined = 0;

  constructor(private settings: SettingsService) {
  }

  ngOnInit(): void {
    return;
  }
}
